export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8276.f11286e8.jpg";